import * as React from 'react';
import { withRouter } from 'react-router';
import GetProductTagsQuery from '../../Query/ProductTags/ProductTags';
import ProductTagSelectControl, { IProductTagSelectProps } from './ProductTagSelect';

class ProductTagSelect extends React.Component<IProductTagSelectProps> {

  public render() {
    return (
      <GetProductTagsQuery
        domain={this.props.match.params.eshop}
      >
        {({ productTags }: any) => {
          if (productTags.loading) {
            return 'Loading product tags ...';
          }

          return (
            <ProductTagSelectControl
              {...this.props}
              tags={productTags.productTags}
            />
          );
        }}
      </GetProductTagsQuery>
    );
  }
}

export default withRouter(ProductTagSelect);


// WEBPACK FOOTER //
// ./src/components/Others/ProductTagSelect/index.tsx